import { MinzeElement, Attrs, Reactive } from 'minze'
import { Font } from '../../constants'
import { Locale } from '../../modules/locale'

Locale.getInstance().registerKeySet('fr', 'lvc-event-block', {
  eventType: 'Événement',
  exhibitionType: 'Exposition',
  seriesType: 'Série',
})

Locale.getInstance().registerKeySet('en', 'lvc-event-block', {
  eventType: 'Event',
  exhibitionType: 'Exhibition',
  seriesType: 'Series',
})

export interface LvcEventBlock {
  eventData: any
  eventName: string
  eventType: string
}

export class LvcEventBlock extends MinzeElement {
  attrs: Attrs = [
    ['event-data', ''],
    ['event-name', ''],
    ['event-type', ''],
  ]

  reactive: Reactive = [
    ['parsedEventData', null],
    ['displayName', ''],
    ['displayType', ''],
  ]

  parsedEventData: any = null
  displayName: string = ''
  displayType: string = ''

  static observedAttributes = ['event-data', 'event-name', 'event-type']

  onAttributeChange(
    name?: string | undefined,
    oldValue?: string | null | undefined,
    newValue?: string | null | undefined
  ): void | Promise<void> {
    if (name === 'event-data' && oldValue !== newValue) {
      this.parseEventData()
    }
  }

  onReady(): void {
    this.parseEventData()
  }

  parseEventData(): void {
    if (!this.eventData) return

    try {
      this.parsedEventData = JSON.parse(decodeURIComponent(this.eventData))

      // Get display name from eventName prop or parsed data
      this.displayName =
        this.eventName ||
        this.parsedEventData?.[Locale.language === 'fr' ? 'nameFr' : 'nameEn'] ||
        this.parsedEventData?.name?.[Locale.language] ||
        ''

      // Get display type
      if (this.eventType) {
        this.displayType = this.eventType
      } else {
        const eventTable = this.parsedEventData?.table || ''
        if (eventTable === 'exhibitionEvents' || eventTable === 'exhibitions') {
          this.displayType = Locale.getKey('lvc-event-block.exhibitionType')
        } else if (eventTable === 'eventSeries' || eventTable === 'series') {
          this.displayType = Locale.getKey('lvc-event-block.seriesType')
        } else {
          this.displayType = Locale.getKey('lvc-event-block.eventType')
        }
      }

      this.rerender()
    } catch (e) {
      console.error('Error parsing event data:', e)
    }
  }

  html = () => {
    return `
      <lvc-box 
        display="flex" 
        flexDirection="column" 
        rowGap="8px" 
        border="1px solid var(--nuit-30, rgba(30, 0, 125, 0.30))" 
        borderRadius="8px" 
        alignItems="flex-start" 
        justifyContent="center" 
        background="#FFF"
        padding="16px"
      >
        <lvc-box class="nameContainer" alignItems="flex-start" width="100%">
          <lvc-text font-preset="smallExtraBold" text-transform="uppercase" lineHeight="120%">
            ${this.displayName}
          </lvc-text>
        </lvc-box>

        <lvc-box display="flex" justifyContent="flex-end" width="100%">
          <lvc-text font-preset="small" font-size="12px">
            ${this.displayType}
          </lvc-text>
        </lvc-box>
      </lvc-box>
    `
  }

  css = () => {
    return `
      :host {
        display: block;
      }
    `
  }
}
